import { ElementRef } from '@angular/core';
import { Control, DomEvent, Map } from 'leaflet';

export const disableMapInteractionsOnElement = (
  nativeElement: HTMLElement,
): HTMLElement => {
  DomEvent.disableClickPropagation(nativeElement);
  DomEvent.disableScrollPropagation(nativeElement);
  return nativeElement;
};

export const createControlWithDisabledMapInteractions = (
  position: string,
  controlElement: ElementRef<HTMLDivElement>,
): Control => {
  return new (Control.extend({
    options: {
      position,
    },
    onAdd: () => disableMapInteractionsOnElement(controlElement.nativeElement),
  }))();
};

export const addControlWithDisabledMapInteractions = (
  position: string,
  controlElement: ElementRef<HTMLDivElement>,
  map: Map,
): Control => {
  const control = createControlWithDisabledMapInteractions(
    position,
    controlElement,
  );
  map.addControl(control);
  return control;
};
